const specificationsData = [
    {
        paroductName:'NVMD-C200',
        specifications:[
            { 
                specificRow:'Sensor Specifications',
                data:[
                    {title:'Resolution',param:'1920*1080 pixels'},
                    {title:'Sensor Frame Rate',param:'50 FPS'},
                    {title:'Recording Format',param:'1920*1080 pixels @ 50 FPS'}
                ]
            },
            { 
                specificRow:'Optical Specifications',
                data:[
                    {title:'Digital Magnification',param:'1 ~ 6x'},
                    {title:'Eye Relief',param:'65 mm / 2.6 inches'},
                    {title:'Field of View',param:'27.0°/15.4°/30.8°'},
                    {title:'Diopter Adjustment',param:'±2D'}
                ]
            },
            { 
                specificRow:'Display Specifications',
                data:[
                    {title:'Type',param:'Micro-OLED'},
                    {title:'Display Resolution',param:'1920×1080 pixels'},
                    {title:'Frame Rate',param:'50 Hz'}
                ]
            },
            { 
                specificRow:'Battery Power Supply',
                data:[
                    {title:'Battery Type',param:'18650 Battery (Flat-top)'},
                    {title:'Operating Time',param:'6 h'},
                    {title:'External Power Supply',param:'5V - Type C USB'}
                ]
            },
            { 
                specificRow:'Physical Specifications',
                data:[
                    {title:'Net Weight',param:'390 g / 13.76 oz'},
                    {title:'Total Weight (incl. Battery & QDS-150)',param:'Approx. 587 g/20.71 oz'},
                    {title:'Dimensions',param:'99 × 73 × 63mm / 3.9 × 2.9 × 2.5 in'},
                    {title:'Built-in Memory',param:'32 GB eMMC (TLC)'},
                    {title:'Ingress Protection Rating',param:'IP67'},
                    {title:'Recoil Rating',param:'800Gs / .50BMG'},
                    {title:'Connections /App',param:'Wi-Fi/ DNT APP'}
                ]
            }
        ]
    } 
]